import { QuoteStatus } from '@graphql';
import { UseNavigateResult } from '@tanstack/react-router';
import { FINANCIAL_PRODUCT } from '@utils/constants';
import { accessibleQuote } from '@utils/helper';

export const handleNavigation = ({
  navigate,
  trackingId,
  quoteStatus,
  hasOpportunityId,
  financialProductId,
}: {
  navigate: UseNavigateResult<string>;
  trackingId: string;
  quoteStatus?: QuoteStatus;
  hasOpportunityId: boolean;
  financialProductId?: string;
}) => {
  if (quoteStatus && !accessibleQuote(quoteStatus)) {
    navigate({ to: '/connect/quoteStatus/', search: { trackingId } });
  } else {
    if (financialProductId === FINANCIAL_PRODUCT.CBA_RESIDENTIAL) {
      return navigate({ to: '/connect/cba/', search: { trackingId } });
    } else if (financialProductId === FINANCIAL_PRODUCT.ELECTRIFY_2515) {
      return navigate({ to: '/connect/electrify2515/', search: { trackingId } });
    } else if (hasOpportunityId) {
      return navigate({ to: '/connect/default/', search: { trackingId } });
    } else {
      return;
    }
  }
};
